// removed by extract-text-webpack-plugin
module.exports = {"Wrapper":"_3Wsee","Title":"_11uLc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Travellers/ChildSelection/ChildSelection.scss
// module id = 874
// module chunks = 0